<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof52">
<p class="centerImage"><img alt="image" id="imgfr41" src="images/imgfr41.jpg"/></p>
<p class="caption1"><em class="italic">Order of St. Anna 4th (3rd) Class. A Small badge fastened to an officer’s sword</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof52.vue?0575a094